import React from 'react'
import LocalASyncStore from '../local-async-store'
import { dayFormat } from '../week'
import List from '../ui/list'
import { NoISSCaseClaims } from './views/empty'
import { ISSCaseClaimListItem } from './views/list-item'
import ISSCaseClaimDetail from './details'
import { days } from './helpers'

const apiEndPoint = ({ record_type, record_id, start_date }) =>
  ['/api', record_type, record_id, 'iss-cases', dayFormat(start_date)].join('/')

export const filterShape = record => {
  const { Type, Status, StartDate } = record.gov_record

  let output = {
    id: record.gov_id,
    Type,
    Status,
    StartDate,
  }

  days(record).forEach((day, i) => {
    output[`day_${i}`] = day
  })

  return output
}

export const ISSCaseClaimsList = ({
  base_url,
  record_type,
  record_id,
  start_date,
  iss_case_claims,
}) => {
  const weekStart = dayFormat(start_date)

  return (
    <List
      base_url={[base_url, weekStart].join('/')}
      loading={iss_case_claims.loading}
      records={iss_case_claims.data}
      emptyComponent={NoISSCaseClaims}
      listComponent={ISSCaseClaimListItem}
      detailComponent={ISSCaseClaimDetail({ record_type, record_id, start_date: weekStart })}
      idField="gov_id"
      filterOn={filterShape}
    />
  )
}

export default LocalASyncStore('iss_case_claims', ISSCaseClaimsList, apiEndPoint)



// WEBPACK FOOTER //
// ./src/iss-case-claims/component.jsx